import React from "react";
import { useNavigate } from "react-router-dom";
import {Avatar,Popover,Button} from "antd";
import TokenStore from "../../store/tokenStore";
import { logOut } from '../../api/user'

const UserAvatar = () => {
    const loginOut=()=>{
        logOut().then(res => {
            TokenStore.removeToken();
            
        })
    }
    const navigate =useNavigate();
    const content=(
        <ul>
            <li><Button type="text" onClick={()=>navigate("/userInfo")}>个人中心</Button></li>
            <li><Button type="text" onClick={()=>loginOut()}>退出登录</Button></li>
        </ul>
    )
    return(
        <Popover content={content}>
            <Avatar style={{color: '#f56a00', backgroundColor: '#fde3cf' }}>U</Avatar>
        </Popover>
    )
}
export default UserAvatar;